/**
 * Created by Qingger Corp.
 * User: yangzihua
 * Date: 2019/6/10
 * Time: 9:37
 * Desc: 网点管理-网点信息-展示配置
 */

import { Component, Inject, Provide, Vue } from 'vue-property-decorator';
import { IPSService } from '@/services/ipsServices';
import { appEnvConfig } from '@/configs/appConfigs';
import { EmpServiceAPIActions } from '@/services/empService';
import { Functions } from '@/library/utils/functions';

// 子组件
import SwiperCp from '@/views/components/pageConfigComponents/swiperCp/swiperCp.vue';
import SwiperEditCp from '@/views/components/pageConfigComponents/swiperEditCp/swiperEditCp.vue';
import ClassGoods from '@/views/components/pageConfigComponents/classGoods/classGoods.vue';
import ClassGoodsEdit from '@/views/components/pageConfigComponents/classGoodsEdit/classGoodsEdit.vue';
import validateParams from '@/library/utils/paramFilter';
import { defaultBg, defaultLogo, selectTypeToTitle } from '@/views/components/newDisplayConfig/shop';

@Component({
  components: {
    SwiperCp,
    SwiperEditCp,
    ClassGoods,
    ClassGoodsEdit,
    // SeckillEdit,
    // SeckillCp
  },
})
export default class DisplayConfig extends Vue {
  $refs: {
    swipeEditCp: any;
  };

  /* 数据 */

  /**
   * 页面配置
   * @type {ItemObject}
   */
  public pageConfig: ItemObject = {
    Swiper: { desc: [] },
    Video: { desc: { url: '' } },
    BackPicture: { desc: {} },
    SecKillActivity: { desc: [] },
  };

  /**
   *  图片上传地址
   *  @type {string}
   */
  public imgTpConfig = `${Functions.ipsHostUrlApi()}/pic/upload/withOut/key`;

  /**
   * token
   * @type {{Authorization: string}}
   */
  public tokenData: ItemObject = {
    Authorization: `Bearer ${EmpServiceAPIActions.getTokenFromCache().token}`,
  };

  /**
   * 页面显示类型
   * @type {string}
   */
  public showType = '';

  /**
   * 选中的模块索引
   * @type {number}
   */
  public chooseIndex = 1;

  /**
   * 店铺logo配置
   * @type {string}
   */
  public showLogo = '';

  /**
   * 店铺名称配置
   * @type {string}
   */
  public showName = '';

  /**
   * 店铺logo地址
   * @type {string}
   */
  public logoUrl = '';

  /**
   * 店铺名称
   * @type {string}
   */
  public shopName = '';

  /**
   * 店铺地址
   * @type {string}
   */
  public shopAddress = '';

  /**
   * 刘海屏是否显示
   * @type {boolean}
   */
  public isBangsShow = false;

  /**
   * 是否展示预览二维码
   * @type {boolean}
   */
  public isShowCode = false;

  /**
   * 二维码图片地址
   * @type {string}
   */
  public imageView = '';

  /**
   * @type {number}
   */
  public gscId = 0;

  /**
   * @type {number}
   */
  public sgwpId = 0;

  /**
   * 店铺地址信息
   * @type {string}
   */
  public siteAddress = '';

  /**
   * 默认店铺头像
   * @type {string}
   */
  public defaultLogo = '';

  /**
   * 默认店铺名称
   * @type {string}
   */
  public defaultShopName = '';

  /* 方法 */

  /**
   * 返回列表
   * @return null
   */
  public toBack() {
    this.$router.go(-1);
  }

  /**
   * 获取页面配置信息
   * @return null
   */
  public getPageConfig(): void {
    IPSService.decorationSiteConfig({
      postParams: {
        siteId: Number.parseInt(this.$route.params.siteId),
      },
    }).then((result) => {
      this.showType = `${result.isShowSitePic || '0'}`;
      this.showLogo = `${result.isDefaultLogo || '0'}`;
      this.showName = `${result.isDefaultName || '0'}`;
      this.pageConfig.Swiper.desc = result.desc || [];
      this.logoUrl = result.siteLogo || '';
      this.shopName = result.siteName || '';
      this.defaultShopName = result.siteName || '';
      this.shopAddress = result.siteAddress || '';
      this.gscId = result.gscId || 0;
      this.sgwpId = result.sgwpId || 0;
      this.siteAddress = result.siteAddress;
    });
  }

  /**
   * 保存展示配置
   * @return null
   */
  public onSubmitDisplayConfig() {
    if (Number(this.showLogo) && !this.logoUrl) {
      this.$message.error('请输上传店铺Logo');
      return false;
    }
    if (Number(this.showName) && !this.shopName) {
      this.$message.error('请输入店铺名称');
      return false;
    }

    const swipeEditCp = validateParams(this.$refs.swipeEditCp.getSwipeData());
    const postParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      gscId: this.gscId,
      sgwpId: this.sgwpId,
      fieldType: 'Swiper',
      desc: Number(this.showType) ? swipeEditCp : [],
      isDefaultLogo: Number(this.showLogo),
      isDefaultName: Number(this.showName),
      siteName: this.shopName,
      siteLogo: this.logoUrl,
      isShowSitePic: Number(this.showType),
    };
    IPSService.decorationSiteConfigSave({ postParams }).then((res) => {
      if (res && res.result) { this.$message.success('保存成功'); }
    });
  }

  /**
   * 图片上传之前的格式验证
   * @param file
   * @returns {boolean}
   */
  beforeAvatarUpload(file) {
    const isJPG = file.type === 'image/jpeg';
    const isPNG = file.type === 'image/png';
    const isGIF = file.type === 'image/gif';
    const isLt500KB = file.size / 1024 < 500;
    if (!isJPG && !isPNG && !isGIF) {
      this.$message.error('上传图片只支持 JPG/JPEG/PNG/GIF 格式!');
    }
    if (!isLt500KB) {
      this.$message.error('上传图片大小不能超过 500KB!');
    }
    return (isJPG || isPNG || isGIF) && isLt500KB;
  }

  /**
   * 图片上传成功时的处理
   * @param res
   * @param file
   */
  handleAvatarSuccess(res: HttpAPIRetItem<any>, file: any) {
    this.pageConfig.BackPicture.desc.url = res.content;
  }

  /**
   * 上传失败提示
   * @param err
   */
  uploadError(err) {
    const result = JSON.parse(err.message);
    if (result.message) {
      this.$message.error(result.message);
    }
  }

  /**
   * 改变选中的模块索引
   * @param index
   */
  public onChangechooseIndex(index): void {
    this.chooseIndex = index;
  }

  /**
   * 关闭预览
   * @return null
   */
  public closePreviewWindow(): void {
    this.isShowCode = false;
  }

  /**
   * 预览
   * @return null
   */
  public preview() {
    // 何少华说 保存怎么传预览就怎么传
    if (Number(this.showLogo) && !this.logoUrl) {
      this.$message.error('请输上传店铺Logo');
      return false;
    }
    if (Number(this.showName) && !this.shopName) {
      this.$message.error('请输入店铺名称');
      return false;
    }

    const swipeEditCp = validateParams(this.$refs.swipeEditCp.getSwipeData());
    const postParams = {
      siteId: Number.parseInt(this.$route.params.siteId),
      gscId: this.gscId,
      sgwpId: this.sgwpId,
      fieldType: 'Swiper',
      desc: Number(this.showType) ? swipeEditCp : [],
      isDefaultLogo: Number(this.showLogo),
      isDefaultName: Number(this.showName),
      siteName: this.shopName,
      siteLogo: this.logoUrl,
      isShowSitePic: Number(this.showType),
    };
    IPSService.siteConfigPreview({ postParams }).then((response) => {
      this.imageView = response.siteQrcode;
      this.isShowCode = true;
    });
  }

  /* 周期 */

  /**
   * 当组建创建时
   */
  public created() {
    this.getPageConfig(); // 获取页面配置信息
    this.getDefaultLogo();
  }

  getDefaultLogo() {
    IPSService.decorationMallInfo({ postParams: { sgId: +this.$route.params.sgId } }).then((res: any) => {
      res.list.forEach((v) => {
        if (v.fieldType === 'Site') {
          this.defaultLogo = (v as NewDisplayShopInfo).desc.siteInfo.siteLogo || defaultLogo;
        }
      });
    });
  }
}
